<template>
  <main class="thanks-page landing-section">
    <div class="landing-container thanks-page__inner">
      <h1 class="thanks-page__title">Спасибо, мы получили вашу заявку</h1>
      <p class="thanks-page__lead">
        Специалист посмотрит ваши ответы, подготовит первичную настройку под вашу компанию и свяжется с вами.
        Обычно на старте мы помогаем определить, какие тендеры стоит отслеживать и как получать релевантную подборку
        без лишнего шума.
      </p>
      <p class="thanks-page__hint">{{ salesContacts.specialistHint }}</p>
      <div class="thanks-page__actions">
        <a
          v-if="salesContacts.telegramUrl"
          :href="salesContacts.telegramUrl"
          class="btn btn--primary"
          target="_blank"
          rel="noopener noreferrer"
          @click="onContactClick('telegram')"
        >
          Написать в Telegram
        </a>
        <a
          v-if="salesContacts.phoneTel"
          :href="`tel:${salesContacts.phoneTel}`"
          class="btn btn--outline"
          @click="onContactClick('phone')"
        >
          Позвонить {{ salesContacts.phoneDisplay }}
        </a>
        <router-link to="/" class="btn btn--ghost" @click="onContactClick('home')">
          Вернуться на сайт
        </router-link>
      </div>
    </div>
    <SalesContactFab />
  </main>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import SalesContactFab from '@/components/landing/SalesContactFab.vue'
import { salesContacts } from '@/config/salesContacts'
import { trackSalesMetrikaGoal } from '@/utils/metrikaGoals'

const PREV_TITLE = typeof document !== 'undefined' ? document.title : ''

function onContactClick() {
  trackSalesMetrikaGoal('contact_click')
}

onMounted(() => {
  document.title = 'Заявка принята — AI-Tenders'
  const meta = document.querySelector('meta[name="robots"]')
  if (meta) meta.setAttribute('content', 'noindex, nofollow')
})

onUnmounted(() => {
  if (PREV_TITLE) document.title = PREV_TITLE
})
</script>

<style scoped>
.thanks-page {
  min-height: 70vh;
  display: flex;
  align-items: center;
  padding: 3rem 0;
  background: var(--surface-alt, #f4f7fb);
}

.thanks-page__inner {
  max-width: 40rem;
  text-align: center;
}

.thanks-page__title {
  margin: 0 0 1rem;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: var(--fg, #0f172a);
}

.thanks-page__lead {
  margin: 0 0 1rem;
  color: var(--muted-strong, #3f4f67);
  line-height: 1.6;
}

.thanks-page__hint {
  margin: 0 0 1.5rem;
  font-size: 0.92rem;
  color: var(--muted, #516078);
}

.thanks-page__actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  align-items: stretch;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.25rem;
  border-radius: 999px;
  font-weight: 700;
  text-decoration: none;
  border: 1px solid transparent;
}

.btn--primary {
  background: #0b6ed8;
  color: #fff;
}

.btn--outline {
  background: #fff;
  border-color: #92b8e8;
  color: #0f172a;
}

.btn--ghost {
  background: transparent;
  color: #516078;
}
</style>
